module.exports = __webpack_public_path__ + "static/media/contact-page.64434f24.jpeg";